import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import { memberData, sortsDatas } from "../../components/Datas";
import { Link, useNavigate } from "react-router-dom";
import { BiChevronDown, BiPlus, BiTime, BiUserX } from "react-icons/bi";
import { BsCalendarMonth } from "react-icons/bs";
import { MdFilterList, MdOutlineCalendarMonth } from "react-icons/md";
import { toast } from "react-hot-toast";
import { Button, FromToDate, Select } from "../../components/Form";
import { PatientTable } from "../../components/Tables";
import staffApi from "../../api/user/staff.api";
import Loading from "../../Util/Loading";

function Staff() {
  const [status, setStatus] = useState(sortsDatas.filterPatient[0]);
  const [gender, setGender] = useState(sortsDatas.genderFilter[0]);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const [isLoading, setIsLoading] = useState(false);
  const [staffs, setStaffs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getAllStaff()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const getAllStaff = async () => {
    try {
      const { response, err } = await staffApi.getAllStaffInfo();

      if (response && response.data) {
        setStaffs(response.data.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const sorts = [
    {
      id: 2,
      selected: status,
      setSelected: setStatus,
      datas: sortsDatas.filterPatient,
    },
    {
      id: 3,
      selected: gender,
      setSelected: setGender,
      datas: sortsDatas.genderFilter,
    },
  ];
  // boxes
  const boxes = [
    {
      id: 1,
      title: "Today Staff",
      value: staffs?.length || 0,
      color: ["bg-subMain", "text-subMain"],
      icon: BiTime,
    },
    // {
    //   id: 2,
    //   title: "Monthly Staff",
    //   value: "230",
    //   color: ["bg-orange-500", "text-orange-500"],
    //   icon: BsCalendarMonth,
    // },
    // {
    //   id: 3,
    //   title: "Yearly Staff",
    //   value: "1,500",
    //   color: ["bg-green-500", "text-green-500"],
    //   icon: MdOutlineCalendarMonth,
    // },
  ];

  // preview
  const previewPayment = (_id) => {
    navigate(`/staff/preview/${_id}`);
  };

  const deleteStaff = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete ${name}?`)) {
      try {
        const { response, err } = await staffApi.deleteStaff(id);
        if (response) {
          toast.success("Staff deleted successfully");
          getAllStaff(); // refresh the list
        } else {
          toast.error("Delete failed");
        }
      } catch (error) {
        toast.error("Something went wrong!");
        console.error("Delete error:", error);
      }
    }
  };

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Layout>
      {/* add button */}
      <Link
        to="/staff/create"
        className="w-16 animate-bounce h-16 border border-border z-50 bg-subMain text-white rounded-full flex-colo fixed bottom-8 right-12 button-fb"
      >
        <BiPlus className="text-2xl" />
      </Link>
      <h1 className="text-xl font-semibold text-text">Staffs</h1>
      {/* boxes */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
        {boxes.map((box) => (
          <div
            key={box.id}
            className="bg-neutral-600 flex-btn gap-4 rounded-xl border-[1px] border-border p-5"
          >
            <div className="w-3/4">
              <h2 className="text-sm font-medium text-text">{box.title}</h2>
              <h2 className="text-xl my-6 font-medium text-text">
                {box.value}
              </h2>
              <p className="text-xs text-textGray">
                Total staffs is{" "}
                <span className={box.color[1]}>{box.value}</span>{" "}
                {box.title === "Today Staff"
                  ? "today"
                  : box.title === "Monthly Staff"
                  ? "this month"
                  : "this year"}
              </p>
            </div>
            <div
              className={`w-10 h-10 flex-colo rounded-md text-white text-md ${box.color[0]}`}
            >
              <box.icon />
            </div>
          </div>
        ))}
      </div>
      {/* datas */}

      <div>
        {staffs.length !== 0 ? (
          <div className="mt-8 overflow-x-auto mb-12">
            <div className="min-w-[600px]">
              <PatientTable
                data={staffs}
                functions={{
                  preview: previewPayment,
                  delete: deleteStaff,
                }}
                used={false}
              />
            </div>
          </div>
        ) : (
          <div className="h-[80%] flex flex-col items-center justify-center text-center text-textGray px-4 my-20">
            <BiUserX size={70} className="mb-6 text-yellowdark" />
            <h1 className="text-2xl font-semibold mb-2">No Staff Found</h1>
            <p className="text-base text-gray-400 mb-8">
              You currently have no staff records. Add a new staff member to get
              started.
            </p>
            <Link
              to="/staff/create"
              className="px-6 py-2 bg-subMain hover:bg-subMain/90 transition-all duration-200 text-yellowdark rounded-full shadow-lg"
            >
              Add New Staff
            </Link>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Staff;
